export default __webpack_public_path__ + "static/media/descrition_blue_icon.a98c2bf9.svg";